/**
 * Utility functions for caching the last used model in the playground.
 * Uses localStorage with project-specific keys.
 */

const STORAGE_KEY_PREFIX = 'PLAYGROUND_LAST_MODEL';

/**
 * Generate the storage key for a specific project
 */
const getStorageKey = (entity: string, project: string): string => {
  return `${STORAGE_KEY_PREFIX}_${entity}_${project}`;
};

/**
 * Get the last used model for a specific project from localStorage
 * @param entity - The entity name
 * @param project - The project name
 * @returns The last used model ID, or null if not found or error occurred
 */
export const getLastUsedModel = (
  entity: string,
  project: string
): string | null => {
  try {
    const key = getStorageKey(entity, project);
    const cachedModel = localStorage.getItem(key);
    return cachedModel;
  } catch (error) {
    return null;
  }
};

/**
 * Save the last used model for a specific project to localStorage
 * @param entity - The entity name
 * @param project - The project name
 * @param modelId - The model ID to cache
 */
export const setLastUsedModel = (
  entity: string,
  project: string,
  modelId: string
): void => {
  try {
    const key = getStorageKey(entity, project);
    localStorage.setItem(key, modelId);
  } catch (error) {
    // Storage failed, but this is non-critical
  }
};
